RoundInfoService = ($http) ->
  getTees: (course_ext_id, ext_type) ->
    $http.get "/api/courses/#{course_ext_id}/tees.json?ext_type=#{ext_type}"

  getHistoryTees: (course_id) ->
    $http.get "/api/course_snapshots/#{course_id}/tees.json"

  getRakutenLink: (rakuten_id) ->
    $http.jsonp 'https://app.rakuten.co.jp/services/api/Gora/GoraGolfCourseDetail/20131113', params:
      format: 'json'
      applicationId: '1083670463465254180'
      affiliateId: '0db0b791.d6e84c38.0db0b792.a2f620e8'
      golfCourseId: rakuten_id

RoundInfoService.$inject = [
  '$http'
]

module.exports = RoundInfoService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/score-registration/round-info/round-info-service.coffee